

































































import { Component, Vue, Prop } from "vue-property-decorator";
import fb from "@/firebaseConfig";
import { Members, Member } from "jsk-shared";
import { refreshChamps, handleError } from "@/api/champs";

@Component
export default class AddEditMembers extends Vue {
  @Prop()
  memberId!: string;

  editMember: Member = {} as Member;
  hasError: boolean = false;
  loading: boolean = false;
  memberNameCache: string = "";
  showDelete: boolean = false;

  created() {
    if (this.memberId != "new") {
      this.getEditMember();
    }
  }

  deleteMember() {
    this.loading = true;

    fb.db
      .collection("cache")
      .doc("memberCache")
      .update({
        members: fb.fsNS.FieldValue.arrayRemove({
          id: this.memberId,
          name: this.memberNameCache
        })
      })
      .then(() => {
        return fb.colMembers.doc(this.memberId).delete();
      })
      .catch(e => {
        console.log("error" + e);
      })
      .finally(() => {
        refreshChamps();
        this.$router.push("/members");
        this.loading = false;
      });
  }

  async saveMember() {
    this.loading = true;

    if (this.memberId === "new") {
      fb.colMembers
        .add(this.editMember)
        .then(doc => {
          return fb.db
            .collection("cache")
            .doc("memberCache")
            .update({
              members: fb.fsNS.FieldValue.arrayUnion({
                id: doc.id,
                name: this.editMember.name
              })
            })
            .then(() => {
              this.$router.push("/members");
            });
        })
        .catch(() => {
          console.log("error");
        })
        .finally(() => {
          refreshChamps();
          this.loading = false;
        });
    } else {
      await fb.colMembers
        .doc(this.memberId)
        .set(this.editMember)
        .then(doc => {
          if (this.memberNameCache != this.editMember.name) {
            fb.db
              .collection("cache")
              .doc("memberCache")
              .update({
                members: fb.fsNS.FieldValue.arrayRemove({
                  id: this.memberId,
                  name: this.memberNameCache
                })
              });
          }

          return fb.db
            .collection("cache")
            .doc("memberCache")
            .update({
              members: fb.fsNS.FieldValue.arrayUnion({
                id: this.memberId,
                name: this.editMember.name
              })
            })
            .then(() => {
              this.$router.push("/members");
            });
        })
        .catch(e => {
          console.log("error" + e);
        })
        .finally(() => {
          refreshChamps();
          this.loading = false;
        });
    }
  }

  getEditMember() {
    this.loading = true;

    fb.colMembers
      .doc(this.memberId)
      .get()
      .then(doc => {
        this.editMember = doc.data() as Member;
        this.memberNameCache = this.editMember.name;
      })
      .catch(() => {
        this.hasError = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
